import React, { useMemo } from 'react';
import { orderBy } from 'lodash';

import Show from 'components/Show';
import Mark from 'components/Ui/Mark';

import { useStudentMarkStore } from 'store/student/useStudentMarkStore';

const Subject = ({ subject }) => {
	// Use student's mark store
	const marks = useStudentMarkStore(state =>
		state.marks.filter(mark => mark.gradeId === state.active && mark.subjectId === subject.id)
	);

	// Find final mark
	const final = useMemo(() => {
		return marks.find(m => m.type === 'final');
	}, [marks]);

	return (
		<tr className="group-one">
			{/* Subject's title */}
			<td className="p-2 pl-3 first:group-one-last:rounded-bl-lg first:border-l border-r border-b border-neutral-100 dark:border-neutral-700 text-neutral-700 dark:text-neutral-200 text-sm font-bold">
				{subject.title}
			</td>

			{/* Either final mark or middle mark */}
			<td className="p-2 last:group-one-last:rounded-br-lg border-r border-b border-neutral-100 dark:border-neutral-700 text-neutral-700 dark:text-neutral-200 text-center font-bold">
				<Show if={final}>
					<Mark
						mark={final?.mark}
						className="text-neutral-700 border-neutral-500 dark:text-neutral-200 dark:border-neutral-200"
					/>
				</Show>
			</td>
		</tr>
	);
};

export default Subject;